import React from 'react';
import PropTypes from 'prop-types';
const sortBy = require('lodash/sortBy');

import WithChannelProjects from '../DataHOCs/WithChannelProjects';
import WithChannelActivities from '../DataHOCs/WithChannelActivities';
import ExpansionButton from '../common/ExpansionButton';
const KeyboardUtil = require("../../util/keyboard");

const propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    tagId: PropTypes.string.isRequired,
    projectStoreState: PropTypes.shape({ initialized: PropTypes.bool, projects: PropTypes.array }).isRequired,
    activityStoreState: PropTypes.shape({ initialized: PropTypes.bool, activities: PropTypes.object }).isRequired,
    onChange: PropTypes.func.isRequired,
    tagUpdates: PropTypes.shape({ 
        add: PropTypes.shape({
            activities: PropTypes.object,
            projects:  PropTypes.object,
        }),
        remove: PropTypes.shape({
            activities: PropTypes.object,
            projects:  PropTypes.object,
        }),
    }).isRequired,
};

const defaultProps = {
    id: 'projs-acts-tree',
    className: '',
};

class SelectableProjectsActivitiesTree extends React.Component {
    constructor(props) {
        super(props);

        let baseexpandedProjectsObj = {};
        this.props.projectStoreState.projects.forEach((project) => {
            baseexpandedProjectsObj[project.id] = false;
        });

        const expandedProjectsObj = this._createExpandedProjectsObj(baseexpandedProjectsObj, this.props.tagId);

        this.state = {
            expandedProjects: expandedProjectsObj
        };

        this.onExpandableClick = this.onExpandableClick.bind(this);
        this.onExpandableKeyDown = this.onExpandableKeyDown.bind(this);
        this.stopPropagation = this.stopPropagation.bind(this);
        this.onChangeActivity = this.onChangeActivity.bind(this);
        this.onChangeProject = this.onChangeProject.bind(this);
    }

    _createExpandedProjectsObj(baseObj, tagId) {
        let expandedProjectsObj = {};
        this.props.projectStoreState.projects.forEach((project) => {
            const projectHasTag = project.integration_tags.find(t => t.id === this.props.tagId);
            if (projectHasTag) {
                expandedProjectsObj[project.id] = baseObj[project.id] || false;
            }
            else {
                const actsForProject = this.props.activityStoreState.activities[project.id] || [];
                const matchingTagRecord = actsForProject.find((act) => {
                    let matchingTagRecord = act.integration_tags.find(t => t.id === this.props.tagId);
                    return !!matchingTagRecord;
                });
                if (!!matchingTagRecord) {
                    expandedProjectsObj[project.id] = true;
                }
                else {
                    expandedProjectsObj[project.id] = baseObj[project.id] || false;
                }
            }
        });

        return expandedProjectsObj;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.tagId !== this.props.tagId) {
            const expandedProjectsObj = this._createExpandedProjectsObj(this.state.expandedProjects, nextProps.tagId);
            this.setState({ expandedProjects: expandedProjectsObj });
        }
    }

    _toggleExpanable(id) {
        this.setState({
            expandedProjects: { ...this.state.expandedProjects, [id]: !this.state.expandedProjects[id] }
        })
    }

    _setExpandedExpandable(id, state) {
        if (this.state.expandedProjects[id] === state) {
            return;
        }

        this.setState({
            expandedProjects: { ...this.state.expandedProjects, [id]: !this.state.expandedProjects[id] }
        });
    }

    onExpandableClick(id, e) {
        this._toggleExpanable(id);
    }

    onExpandableKeyDown(id, e) {
        if (KeyboardUtil.isSelectKey(e.keyCode)) {
            this._toggleExpanable(id);
        }
        else if (KeyboardUtil.isRightArrow(e.keyCode)) {
            this._setExpandedExpandable(id, true);
        }
        else if( KeyboardUtil.isLeftArrow(e.keyCode)) {
            this._setExpandedExpandable(id, false);
        }
    }

    stopPropagation(e) {
        e.stopPropagation();
    }

    onChange(newTagUpdatesObj) {
        if (!this.props.onChange) {
            return;
        }

        this.props.onChange(newTagUpdatesObj);
    }

    onChangeActivity(projectId, activityId, e) {
        const activity = this.props.activityStoreState.activities[projectId].find(a => a.id === activityId);
        const project = this.props.projectStoreState.projects.find(p => p.id === projectId);
        const checked = e.target.checked;
        const hasTag = !!activity.integration_tags.find(t => t.id === this.props.tagId);
        const projectHasTag = !!project.integration_tags.find(t => t.id === this.props.tagId);
        const toBeAdded = !!this.props.tagUpdates.add.activities[activityId];
        const toBeRemoved = !!this.props.tagUpdates.remove.activities[activityId];

        let newTagUpdatesObj = { ...this.props.tagUpdates };
        if (!hasTag && checked) {
            newTagUpdatesObj.add.activities[activityId] = true;
        }
        else if (hasTag && !checked) {
            newTagUpdatesObj.remove.activities[activityId] = true;
        }
        else if (!hasTag && toBeAdded && !checked) {
            delete newTagUpdatesObj.add.activities[activityId];   
        }
        else if (hasTag && toBeRemoved && checked) {
            delete newTagUpdatesObj.remove.activities[activityId];
        }

        this.onChange(newTagUpdatesObj);
    }

    onChangeProject(projectId, e) {
        const project = this.props.projectStoreState.projects.find(p => p.id === projectId);
        const activityIdsForProject = this.props.activityStoreState.activities[project.id].map(a => a.id);
        const checked = e.target.checked;
        const projectHasTag = !!project.integration_tags.find(t => t.id === this.props.tagId);
        const toBeAdded = !!this.props.tagUpdates.add.projects[projectId];
        const toBeRemoved = !!this.props.tagUpdates.remove.projects[projectId];

        let newTagUpdatesObj = { ...this.props.tagUpdates };
        if (!projectHasTag && checked) {
            newTagUpdatesObj.add.projects[projectId] = true;
            // delete any-to-be-added for activities in this project
            activityIdsForProject.forEach((actId) => {
                if (newTagUpdatesObj.add.activities[actId]) delete newTagUpdatesObj.add.activities[actId];
            });
        }
        else if (projectHasTag && !checked) {
            newTagUpdatesObj.remove.projects[projectId] = true;
        }
        else if (!projectHasTag && toBeAdded && !checked) {
            delete newTagUpdatesObj.add.projects[projectId];
        }
        else if (projectHasTag && toBeRemoved && checked) {
            delete newTagUpdatesObj.remove.projects[projectId];
        }

        this.onChange(newTagUpdatesObj);
    }

    render() {
        const self = this;
        const projects = sortBy(this.props.projectStoreState.projects, p => p.name.toLowerCase());
        const activities = this.props.activityStoreState.activities;

        return (
            <ul
            className={`exp-tree ${this.props.className}`}
            id={this.props.id}
            >
                {projects.map((project) => {
                    const pHasTag = !!project.integration_tags.find(tag => tag.id === self.props.tagId);
                    const pToBeAdded = !!this.props.tagUpdates.add.projects[project.id];
                    const pToBeRemoved = !!this.props.tagUpdates.remove.projects[project.id];
                    const projectIsSelected = (pHasTag && !pToBeRemoved) || (!pHasTag && pToBeAdded);

                    return (
                        <li
                        key={project.id}
                        className="exp-expandable--noSpacing alternateBgColor"
                        >
                            <div className="padding-tb-md padding-lr-md border-bottom-gray">
                                <ExpansionButton
                                className="margin-right-md"
                                expanded={this.state.expandedProjects[project.id]}
                                ariaText="Show Activities"
                                onClick={this.onExpandableClick.bind(this, project.id)}
                                />
                                <label htmlFor={`it-proj-${project.id}`}>
                                    {project.name} ({activities[project.id] ? activities[project.id].length : '0'})
                                </label>
                                <input
                                id={`it-proj-${project.id}`}
                                className="fr"
                                type="checkbox"
                                checked={projectIsSelected}
                                onChange={self.onChangeProject.bind(this, project.id)}
                                />
                            </div>
                            {/* onClick & onKeyDown stopPropagation handlers prevent clicks getting through 'ui holes' from bubbling up to expandable handler */}
                            <ul
                            onClick={this.stopPropagation}
                            onKeyDown={this.stopPropagation}
                            style={self.state.expandedProjects[project.id] ? {}: { display: "none" }}
                            >
                                {activities[project.id].map((activity) => {
                                    const aHasTag = !!activity.integration_tags.find(tag => tag.id === self.props.tagId);
                                    const aToBeAdded = !!this.props.tagUpdates.add.activities[activity.id];
                                    const aToBeRemoved = !!this.props.tagUpdates.remove.activities[activity.id];
                                    const activityIsSelected = (aHasTag && !aToBeRemoved) || (!aHasTag && aToBeAdded) || projectIsSelected;
                                    
                                    return (
                                        <li
                                        key={activity.id}
                                        aria-checked={activityIsSelected}
                                        className="exp-selectable--tall alternateBgColor border-bottom-gray padding-lr-md exp-l1--noIcon"
                                        >
                                            <label
                                            htmlFor={`it-act-${activity.id}`}
                                            >
                                                {activity.meta_data.title}
                                            </label>
                                            <input
                                            id={`it-act-${activity.id}`}
                                            className="fr"
                                            type="checkbox"
                                            checked={activityIsSelected}
                                            onChange={this.onChangeActivity.bind(this, project.id, activity.id)}
                                            disabled={projectIsSelected}
                                            />
                                        </li>
                                    );
                                })}
                                {!activities[project.id].length &&
                                    <li
                                    className="exp-selectable--tall alternateBgColor border-bottom-gray padding-lr-md text-centered"
                                    >
                                        No activities
                                    </li>
                                }
                            </ul>
                        </li>
                    );
                })}
            </ul>
        );
    }
}

SelectableProjectsActivitiesTree.propTypes = propTypes;
SelectableProjectsActivitiesTree.defaultProps = defaultProps;

export default WithChannelProjects(WithChannelActivities(SelectableProjectsActivitiesTree));